module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "natashaGifCircle.45f52881.gif";